var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VueRecaptcha", {
    attrs: { sitekey: this.sitekey, loadRecaptchaScript: true },
    on: { verify: _vm.validate }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Login/Recaptcha.vue?vue&type=template&id=6c60f636&
// module id = null
// module chunks = 